import { render, staticRenderFns } from "./BANotify.vue?vue&type=template&id=30a050c6&scoped=true"
import script from "./BANotify.vue?vue&type=script&lang=js"
export * from "./BANotify.vue?vue&type=script&lang=js"
import style0 from "./BANotify.vue?vue&type=style&index=0&id=30a050c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a050c6",
  null
  
)

export default component.exports